var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7167 21.5L12.0458 13.8292C11.4625 14.3347 10.7823 14.7285 10.0054 15.0104C9.22838 15.2924 8.40159 15.4333 7.525 15.4333C5.42185 15.4333 3.6419 14.7042 2.18514 13.2458C0.728379 11.7875 0 10.0278 0 7.96667C0 5.90556 0.729167 4.14583 2.1875 2.6875C3.64583 1.22917 5.41042 0.5 7.48125 0.5C9.55208 0.5 11.3118 1.22917 12.7604 2.6875C14.209 4.14583 14.9333 5.90701 14.9333 7.97104C14.9333 8.80424 14.7972 9.60972 14.525 10.3875C14.2528 11.1653 13.8444 11.8944 13.3 12.575L21 20.2167L19.7167 21.5ZM7.49583 13.6833C9.07569 13.6833 10.4186 13.1243 11.5245 12.0063C12.6304 10.8882 13.1833 9.54167 13.1833 7.96667C13.1833 6.39167 12.6304 5.04514 11.5245 3.92708C10.4186 2.80903 9.07569 2.25 7.49583 2.25C5.89978 2.25 4.54312 2.80903 3.42586 3.92708C2.30862 5.04514 1.75 6.39167 1.75 7.96667C1.75 9.54167 2.30862 10.8882 3.42586 12.0063C4.54312 13.1243 5.89978 13.6833 7.49583 13.6833Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifyingGlass.f1966c54feb4ed7111b323c55985e43a.svg";
export { ForwardRef as ReactComponent };